import styled from 'styled-components';
import UIAvatar from '../../../../../core/components/Avatar';
export const Avatar = styled(UIAvatar) `
  margin-right: 8px;
`;
//# sourceMappingURL=styles.js.map